import { isValidDate } from './../../../../utils/helps';
import { ObjectMapper } from 'json-object-mapper';
import moment from 'moment';
import { IModel } from '../IModel';
import { ApplicantModel } from './applicant.model';
import { ApplicantDependentModel } from './applicantDependent.model';
import { ShirtSizeEnum } from 'services/enums/ShirtSize.enum';

export class ApplicantFormModel extends ApplicantModel implements IModel<ApplicantFormModel> {
  maritalStatus: number = 1;
  sex: number = 1;
  birthDate: string = '';
  nickname: string = '';
  dependentNumber: number = 0;
  racialDistinction: number = 9;
  schooling: number = 35;
  nationality: string = '';
  birthplace: string = '';
  birthState: string = '';
  fathersName: string = '';
  mothersName: string = '';
  bankNumber: string = '';
  bankAgency: string = '';
  bankAccountNumber: string = '';
  bankAccountDigit: string = '';
  zipCode: string = '';
  street: string = '';
  streetType: string = '';
  addressComplement: string = '';
  houseNumber: string = '';
  neighborhood: string = '';
  city: string = '';
  state: string = '';
  contact1: string = '';
  emergencyContact: string = '';
  email: string = '';
  electoralCard: string = '';
  electoralSection: string = '';
  electoralZone: string = '';
  rg: string = '';
  rgIssuer: string = '';
  rgState: string = '';
  rgDate: string = '';
  pis: string = '';
  ctpsNumber: string = '';
  ctpsSerie: string = '';
  ctpsState: string = '';
  ctpsIssueDate: string = '';
  militaryDischarge: string = '';
  applicantId: string | undefined = undefined;
  dependents: ApplicantDependentModel[] = [];
  insalubrityLevel: number = 1;
  dangerousness: boolean = false;
  shoeSize: number = 0;
  shirtSize: any = ShirtSizeEnum.M.value;
  pantsSize: number = 0;
  emergencyName: string = '';
  emergencyPhone: string = '';
  emergencyKinship: string = '';
  emergencyEmail: string = '';
  organizationId: string | undefined = undefined;

  static create(input: any): ApplicantFormModel {
    return ObjectMapper.deserialize<ApplicantFormModel>(ApplicantFormModel, input);
  }

  public formatDates() {
    if (!isValidDate(this.birthDate)) {
      const birthDateValid = moment(this.birthDate).format('DD/MM/YYYY').toString();
      this.birthDate =
        birthDateValid !== 'Invalid date' && birthDateValid !== '01/01/0001' ? birthDateValid : '';
    }

    if (!isValidDate(this.rgDate)) {
      const rgDateValid = moment(this.rgDate).format('DD/MM/YYYY').toString();
      this.rgDate =
        rgDateValid !== 'Invalid date' && rgDateValid !== '01/01/0001' ? rgDateValid : '';
    }

    if (!isValidDate(this.ctpsIssueDate)) {
      const ctpsIssueDateValid = moment(this.ctpsIssueDate).format('DD/MM/YYYY').toString();
      this.ctpsIssueDate =
        ctpsIssueDateValid !== 'Invalid date' && ctpsIssueDateValid !== '01/01/0001'
          ? ctpsIssueDateValid
          : '';
    }
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
